import { featureLookUp } from "../featureStaging-local";
import { tryGetHostApi } from "./externalApi";
export function isFeatureEnabled(featureName) {
    var _a;
    const velocityApi = (_a = window.__com_microsoft_dsh_widgetModelApiFactory) === null || _a === void 0 ? void 0 : _a.tryGetApi("velocity", 1, 1);
    if (velocityApi) {
        return velocityApi.isFeatureEnabled(featureName);
    }
    else {
        return false;
    }
}
export async function isFeatureEnabledInternal(featureName) {
    const dashboardHostApi = await tryGetHostApi("Velocity", 1, 1);
    if (dashboardHostApi) {
        return await dashboardHostApi.isFeatureEnabled(featureName);
    }
    else {
        let result = featureLookUp.get(featureName);
        return result ? result : false;
    }
}
